import { FullVintage, FullWine, t } from '@vivino/js-web-common';
import React from 'react';
import NoteIcon from 'vivino-ui/icons/Note';

const TRANSLATIONS = {
  wineDescription: 'common.wine_description',
};

interface VintageType extends Omit<FullVintage, 'wine'> {
  wine: FullWine;
}

type WineDescription = {
  key: string;
  headerLabel: JSX.Element;
  icon: any;
  values: Array<{ name: any }>;
} | null;

export const getWineDescription = (vintage: VintageType, translationFunc = t): WineDescription => {
  const description = vintage?.wine?.description;
  if (!description) {
    return null;
  }
  return {
    key: 'wineDescription',
    headerLabel: <h3>{translationFunc(TRANSLATIONS.wineDescription)}</h3>,
    icon: NoteIcon,
    values: [{ name: <span dangerouslySetInnerHTML={{ __html: description }} /> }],
  };
};
